/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.9.0",
  "gitBuildTime": "2026-09-21T18:40:22.074Z",
  "gitBuildVersion": "2.9.0",
  "gitCommitId": "6cdb696",
  "gitCommitIdFull": "6cdb69634676be14acc2ddd5ab793821dd9d3353",
  "gitCommitTime": "2026-09-21T18:38:49.000Z",
  "version": "2.9.0-2026-09-21T18:38:49.000Z-(6cdb696)"
};
